export const contactChannels = [
  {
    id: 'visit',
    icon: 'ri-map-pin-2-line',
    title: 'Visit Our Unit',
    lines: ['13.A, Habiba Manzil,', 'Sankar Nagar 2nd Street,', 'K.Pudur, Madurai - 625 007', 'Tamil Nadu, India'],
    actionLabel: 'Get Directions',
    actionHref: 'https://www.google.com/maps/search/Best+Research+Pharma+Madurai',
    accent: 'primary',
  },
  {
    id: 'call',
    icon: 'ri-phone-line',
    title: 'Call Us',
    lines: ['+91 74185 78761', '+91 98421 78761'],
    actionLabel: 'Call Sales Team',
    actionHref: 'tel:+917418578761',
    accent: 'accent',
  },
  {
    id: 'email',
    icon: 'ri-mail-line',
    title: 'Email Us',
    lines: ['bestresearchpharma@gmail.com', 'Replies within one business day'],
    actionLabel: 'Send an Email',
    actionHref: 'mailto:bestresearchpharma@gmail.com',
    accent: 'secondary',
  },
  {
    id: 'hours',
    icon: 'ri-time-line',
    title: 'Working Hours',
    lines: ['Mon - Sat', '9:30 AM - 7:00 PM', 'Sunday: Closed'],
    actionLabel: 'Enquire Now',
    actionHref: '#enquiry',
    accent: 'primary',
  },
];

export const departments = [
  {
    id: 'sales',
    icon: 'ri-shopping-bag-3-line',
    title: 'Sales & Enquiries',
    description: 'Product questions, pricing and order assistance.',
    email: 'bestresearchpharma@gmail.com',
    phone: '+91 74185 78761',
  },
  {
    id: 'distribution',
    icon: 'ri-hand-heart-line',
    title: 'Distribution & Partnership',
    description: 'Distributorship, stockist and bulk supply enquiries.',
    email: 'bestresearchpharma@gmail.com',
    phone: '+91 98421 78761',
  },
  {
    id: 'support',
    icon: 'ri-customer-service-2-line',
    title: 'Customer Support',
    description: 'Product usage guidance and after-sales support.',
    email: 'bestresearchpharma@gmail.com',
    phone: '+91 74185 78761',
  },
];

export const contactFaqs = [
  {
    id: 'f1',
    question: 'Are your products GMP and ISO certified?',
    answer:
      'Yes. All our products are manufactured in a State-licensed, Schedule T GMP-certified unit operating under an ISO 9001:2015 quality management system.',
  },
  {
    id: 'f2',
    question: 'Do you supply in bulk or to distributors?',
    answer:
      'Absolutely. We work with distributors, stockists, pharmacies and clinics across India. Share your requirement using the enquiry form and our partnership team will get in touch.',
  },
  {
    id: 'f3',
    question: 'Do you offer third-party manufacturing?',
    answer:
      'Yes, we offer Ayurvedic third-party manufacturing. Contact our distribution team with your requirement and we will guide you through the process.',
  },
  {
    id: 'f4',
    question: 'How quickly will I get a reply?',
    answer:
      'Our team usually responds within one business day. For urgent requirements, please call us directly on the numbers listed above.',
  },
  {
    id: 'f5',
    question: 'Where are your products available?',
    answer:
      'Our medicines are available through a growing network of 300+ distributors across 18+ states in India, and you can also reach us directly for orders.',
  },
];